var map = {
	"./arrow.svg": 12505,
	"./bar-code-error.svg": 17188,
	"./black-friday/line.svg": 88570,
	"./boleto.svg": 77521,
	"./cancelamento-error.svg": 80201,
	"./cancelamento-info.svg": 17349,
	"./cancelamento-livro.svg": 43595,
	"./cancelamento-medicamento.png": 97877,
	"./cancelamento-money.svg": 76139,
	"./cancelamento-pig-bank.svg": 99298,
	"./cancelamento-success.svg": 73626,
	"./cancelamento-tem-certeza.png": 13754,
	"./cancelamento-wifi-off.svg": 23218,
	"./card-error.svg": 99889,
	"./check-active.svg": 70481,
	"./check-error.svg": 13791,
	"./check-success.svg": 82084,
	"./check.svg": 3954,
	"./close-icon-blue.svg": 14761,
	"./error-icon.svg": 93650,
	"./eye.svg": 13821,
	"./icon-american-express.svg": 40415,
	"./icon-barcode.svg": 50254,
	"./icon-card-error.svg": 60917,
	"./icon-cep-spinner.svg": 51286,
	"./icon-dinners-club.svg": 64682,
	"./icon-elo.svg": 34980,
	"./icon-iugu.svg": 55620,
	"./icon-master-card.svg": 41027,
	"./icon-visa.svg": 57909,
	"./iugu.svg": 44888,
	"./logo-elo.svg": 82970,
	"./logo-mastercard.svg": 57760,
	"./logo-other.svg": 78874,
	"./logo-visa.svg": 22547,
	"./logo-whitebook.svg": 66316,
	"./star.svg": 18946,
	"./wb-logo.svg": 6711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43672;